<template>
  <AppCard design="new" class="integration-filter-card">
    <slot name="selection" />
    <div
      class="integration-filter-grid"
      :class="{ 'integration-filter-grid--five-columns': integration === 'telegram' }"
    >
      <template v-if="loading">
        <div v-for="index in filters.length + 2" :key="index" class="integration-filter-skeleton" aria-hidden="true">
          <span class="integration-filter-skeleton__label" />
          <span class="integration-filter-skeleton__control" />
        </div>
      </template>
      <template v-else>
        <AppFormGroup
          design="new"
          label="Search"
          label-for="integration-search"
          class="integration-filter integration-filter--search"
        >
          <AppInput
            id="integration-search"
            :value="search"
            design="new"
            type="search"
            maxlength="255"
            placeholder="ID, recipient or message"
            @input="$emit('search', $event)"
            @keydown.enter.native="$emit('submit-search')"
          />
        </AppFormGroup>
        <AppFormGroup
          design="new"
          label="Period · Asia/Dubai"
          label-for="integration-period"
          class="integration-filter integration-filter--period"
        >
          <AppDatePicker
            :value="period"
            design="new"
            range
            :input-attr="{ id: 'integration-period' }"
            placeholder="All dates"
            @input="setPeriod"
          />
        </AppFormGroup>
        <AppFormGroup
          v-for="filter in filters"
          :key="filter.key"
          design="new"
          class="integration-filter"
          :label="filter.label"
          :label-for="`integration-${filter.key}`"
        >
          <AppSelect
            :value="selected(filter)"
            design="new"
            label="label"
            :input-id="`integration-${filter.key}`"
            :aria-label="filter.label"
            :options="values(filter)"
            :reduce="(option) => option.value"
            :disabled="single(filter)"
            :clearable="!single(filter)"
            placeholder="All"
            @input="change(filter.key, $event)"
          />
        </AppFormGroup>
      </template>
    </div>
    <div class="integration-toolbar">
      <span class="integration-muted">Period uses the creation time in Board.</span>
      <AppClearFiltersButton design="new" @clear="$emit('clear')" />
    </div>
    <div v-if="error" class="integration-error" role="alert">
      {{ error }}
      <AppButton design="new" theme="dark" size="small" @click.native="$emit('retry')">Retry filter options</AppButton>
    </div>
  </AppCard>
</template>

<script>
import { queryPeriod, periodQuery } from './model'
export default {
  props: { query: Object, options: Object, integration: String, operations: Boolean, search: String, loading: Boolean, error: String },
  computed: {
    period() { return queryPeriod(this.query) },
    filters() {
      const account = { key: 'account', options: 'accounts', label: this.integration === 'telegram' ? 'Bot' : this.integration === 'whatsapp' ? 'Account/channel' : this.integration === 'knowledge_ai' ? 'Profile' : 'Account' }
      const sender = { key: 'sender', options: 'senders', label: 'Sender' }
      if (this.operations) {
        const filters = [{ key: 'source', options: 'sources', label: 'Source' }, account]
        if (['telegram', 'whatsapp', 'knowledge_ai'].includes(this.integration)) filters.unshift({ key: 'operation_type', options: 'operation_types', label: 'Operation' })
        if (['whatsapp', 'email'].includes(this.integration)) filters.push({ key: 'provider', options: 'providers', label: 'Provider' })
        if (['email', 'sendpulse'].includes(this.integration)) filters.push(sender)
        return filters
      }
      const filters = [{ key: 'result', options: 'results', label: 'Result' }]
      if (['telegram', 'whatsapp', 'knowledge_ai'].includes(this.integration)) filters.push({ key: 'method', options: 'methods', label: 'Method' }, account)
      if (['email', 'sendpulse'].includes(this.integration)) filters.push(sender)
      return filters
    }
  },
  methods: {
    values(filter) {
      return (this.options[filter.options] || []).map(option => typeof option === 'string' ? { value: option, label: option.replace(/_/g, ' ').replace(/^./, char => char.toUpperCase()) } : option)
    },
    single(filter) { return ['account', 'provider'].includes(filter.key) && this.values(filter).length === 1 && (!this.query[filter.key] || this.query[filter.key] === this.values(filter)[0].value) },
    selected(filter) { return this.query[filter.key] || (this.single(filter) ? this.values(filter)[0].value : null) },
    change(key, value) {
      this.$emit('change', { [key]: value })
    },
    setPeriod(value) { this.$emit('change', periodQuery(value)) }
  }
}
</script>
